import React from 'react';
import { Link } from 'react-router-dom';

const Service = (props) => {
    const {id,title, description,name, img} = props.disease;
    ;
    return (
      <div>
      <div className="col">
 <div className="card">
  
   <img height="400px" src={img} className="card-img-top" alt="..."/>
   <h5>{id}</h5>
   <div className="card-body">
     <h5 className="card-title">{title}</h5>
     <h5 className="card-name">{name}</h5>
     <p className="card-text">{description}</p>
     <Link to='/services'><button className="btn btn-danger">View More</button></Link>
   </div>
 </div>
</div>
</div>
 
    );
};

export default Service;